import { useCallback, useMemo, useRef } from 'react';
import { List } from 'immutable';
import { useConfiguredMentionsPlugin } from './useConfiguredMentionsPlugin';
import { detectMentionChanges } from '../TeamMentionUtils';
export function useAtMentionPlugin({
  owners,
  teams,
  onMentionChange,
  onSave,
  onChange,
  onStateCreated
}) {
  const initialMentionsRef = useRef(null);
  const previousMentionsRef = useRef(null);
  const internalOnMentionChange = useCallback(current => {
    var _previousMentionsRef$;
    const previous = (_previousMentionsRef$ = previousMentionsRef.current) !== null && _previousMentionsRef$ !== void 0 ? _previousMentionsRef$ : {
      teamIds: [],
      userIds: []
    };
    const changes = detectMentionChanges(previous, current);
    previousMentionsRef.current = current;
    if (onMentionChange) {
      onMentionChange(current, changes);
    }
  }, [onMentionChange]);
  const {
    mentionsPlugins,
    processAtMentions
  } = useConfiguredMentionsPlugin(owners, teams, internalOnMentionChange);
  const wrappedOnSave = useCallback(rteResult => {
    var _initialMentionsRef$c;
    const processed = processAtMentions(rteResult.atMentions());
    const initial = (_initialMentionsRef$c = initialMentionsRef.current) !== null && _initialMentionsRef$c !== void 0 ? _initialMentionsRef$c : {
      teamIds: [],
      userIds: []
    };
    const mentionChanges = detectMentionChanges(initial, processed.separated);
    onSave({
      atMentions: () => List(processed.expanded),
      html: () => rteResult.html(),
      editorState: rteResult.editorState,
      mentionTracking: processed.separated,
      mentionChanges
    });
  }, [processAtMentions, onSave]);
  const wrappedOnChange = useMemo(() => onChange ? rteResult => {
    const processed = processAtMentions(rteResult.atMentions());
    onChange({
      atMentions: () => List(processed.expanded),
      html: () => rteResult.html(),
      editorState: rteResult.editorState,
      mentionTracking: processed.separated
    });
  } : undefined, [onChange, processAtMentions]);
  const wrappedOnStateCreated = useCallback(rteResult => {
    const processed = processAtMentions(rteResult.atMentions());
    initialMentionsRef.current = processed.separated;
    previousMentionsRef.current = processed.separated;
    if (onStateCreated) {
      onStateCreated({
        atMentions: () => List(processed.expanded),
        html: () => rteResult.html(),
        editorState: rteResult.editorState,
        mentionTracking: processed.separated
      });
    }
  }, [onStateCreated, processAtMentions]);
  return {
    mentionsPlugins,
    onSave: wrappedOnSave,
    onChange: wrappedOnChange,
    onStateCreated: wrappedOnStateCreated
  };
}